import { createFileRoute } from '@tanstack/react-router';
import { Center, Stack, Text } from '@mantine/core';
import { SearchBarWithSuggestions } from '@/features/search/components/SearchBarWithSuggestions';

export const Route = createFileRoute('/')({
  component: Index,
});

function Index() {
  return (
    <Center h="70vh">
      <Stack align="center" gap="xl" w="100%">
        <Text size="xxl" ta="center">
          CadCare Connect
        </Text>
        <SearchBarWithSuggestions centered/>
      </Stack>
    </Center>
  );
}